export default "__VITE_ASSET__1f4d2442__"